<template>
  <div class="contents">
    <div class="d-flex section-title-with-back" v-if="id">
      <img src="@/assets/images/Icon awesome-pen.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">教場編集</p>
    </div>
    <div class="d-flex section-title-with-back" v-else>
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt="" width="25" height="25" />
      <p class="title-bk">教場登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'school-id-edit' : 'school-add', params: id ? { id } : {} }">
        戻る
      </router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <th scope="row" width="30%">以下の内容で登録しますか？</th>
            <td />
          </tr>
          <tr>
            <th scope="row">法人名（法人ID）</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">教場ID</th>
            <td>{{ currentSchool.uid }}</td>
          </tr>
          <tr>
            <th scope="row">教場名</th>
            <td>{{ currentSchool.name }}</td>
          </tr>
          <tr>
            <th scope="row">教場名（フリガナ）</th>
            <td>{{ currentSchool.nameReading }}</td>
          </tr>
          <tr>
            <th scope="row">郵便番号</th>
            <td>{{ currentSchool.postalCode }}</td>
          </tr>
          <tr>
            <th scope="row">都道府県 市区町村</th>
            <td>{{ currentSchool.state }}</td>
          </tr>
          <tr>
            <th scope="row">番地・建物名</th>
            <td>{{ currentSchool.address }}</td>
          </tr>
          <tr>
            <th scope="row">電話番号</th>
            <td>{{ currentSchool.phone }}</td>
          </tr>
          <tr>
            <th scope="row">FAX番号</th>
            <td>{{ currentSchool.fax }}</td>
          </tr>
          <tr>
            <th scope="row">メールアドレス</th>
            <td>{{ currentSchoolEmail }}</td>
          </tr>
          <tr>
            <th scope="row">利用教材</th>
            <td>{{ currentSchoolProducts }}</td>
          </tr>
        </tbody>
      </table>
      <div class="text-center">
        <button type="button" class="btn-confirm" @click="confirmRevised">修正</button>
        <button type="button" class="btn-red" @click="confirmSaved" :disabled="isLoading">登録</button>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="一覧に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header v-if="id">教場編集</template>
        <template v-slot:header v-else>教場登録</template>
        <template v-slot:body v-if="id">教場の登録情報の編集が完了しました！</template>
        <template v-slot:body v-else>教場の登録が完了しました！</template>
      </PopUpHolder>
      <b-alert variant="danger" v-show="errorMessage" dismissible show>{{ errorMessage }}</b-alert>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import {
  basicPresent,
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicProductName,
} from '@/presenters/fields';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import sortBy from 'lodash/sortBy';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  components: {
    PopUpHolder,
  },
  data() {
    return {
      errorMessage: null,
      isLoading: false,
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      if (store.getters['school/existsUpdateRequiredParams']) {
        store.dispatch('school/fetchSchool', routeTo.params.id).then(() => {
          next();
        });
      } else {
        next({ name: 'school-id-edit', params: { id: routeTo.params.id } });
      }
    } else {
      if (store.getters['school/existsRegistrationRequiredParams']) {
        next();
      } else {
        next({ name: 'school-add' });
      }
    }
  },
  computed: {
    currentSchool() {
      if (this.school.editingSchool) {
        return this.school.editingSchool;
      } else {
        return this.school.school;
      }
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentSchool.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentSchool.brand);
    },
    currentSchoolEmail() {
      return basicPresent(this.currentSchool.email);
    },
    currentSchoolProducts() {
      if (Array.isArray(this.currentSchool.figuredProducts)) {
        const sortedProducts = sortBy(this.currentSchool.figuredProducts, 'position');
        return basicProductName(sortedProducts);
      }
      return basicPresent();
    },
    ...mapState(['school']),
  },
  methods: {
    confirmRevised() {
      if (this.id) {
        // This path is for Editing existing School flow
        this.$logger.debug('Need revise, go back to ID ' + this.id);
        this.$router.push({ name: 'school-id-edit', params: { id: this.id } });
      } else {
        // This path is for Adding new School flow
        this.$logger.debug('Need revise, go back');
        this.$router.push({ name: 'school-add' });
      }
    },
    confirmSaved() {
      this.$logger.debug('Finished Editing: ' + JSON.stringify(this.currentSchool));
      if (this.id) {
        // This path is for Editing existing School flow
        this.finishEditingSchool(this.id).then(
          (response) => {
            this.$logger.debug('Show success popup ' + response);
            this.$refs['popup_holder'].show();
          },
          (error) => {
            this.errorMessage = error;
            this.$logger.debug('Error ' + error);
          }
        );
      } else {
        this.isLoading = true;
        // This path is for Adding new School flow
        this.finishEditingSchool().then(
          (response) => {
            this.$logger.debug('Show success popup ' + response);
            this.$refs['popup_holder'].show();
          },
          (error) => {
            this.isLoading = false;
            this.errorMessage = error;
            this.$logger.debug('Error ' + error);
          }
        );
      }
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      this.$router.push({ name: 'school' });
    },
    ...mapActions('school', ['finishEditingSchool']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
